import { connect } from "react-redux";
import ViewLead from "./viewLead";
import { bindActionCreators } from "redux";
import { getContractDetails } from "services/redux/sales/preSaleListing/action";
import { contractInvoicePreview } from "services/redux/sales/postSales/contractNew/action";

const mapStateToProps = (state) => ({
  viewDetails: state.preSalesListReducer.viewContract
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getContractDetails,
      contractInvoicePreview,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewLead);
